module.exports = __webpack_public_path__ + "img/OBA.58b7596c.png";